module.exports = __webpack_public_path__ + "img/10e11411c45680144989bbb99545d0b1.b9bf8cb8.jpg";